
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/reserves",
      function () {
        return require("private-next-pages/docs/transfer/reserves.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/reserves"])
      });
    }
  